const state = {
  persona: {
    tipoPersona: 0,
    bancaActiva: 0,
    Id_domicilio: 0,
    datosPersonales: {
      numero: '',
      nombre: '',
      apellidoP: '',
      apellidoM: '',
      rfc: '',
      curp: '',
      fechaNacimiento: '',
      celular: '',
    },
    datosDomicilio: {
      calle: '',
      numExt: '',
      numInt: '',
      cp: '',
      selectedEntidad: '',
      selectedColonia: '',
      selectedMunicipio: '',
    },
  },
  domicilioOriginal: {
    calle: '',
    numExt: '',
    numInt: '',
    cp: '',
    selectedEntidad: '',
    selectedColonia: '',
    selectedMunicipio: '',
  },
  motivosCancelacion: [],
  generoPersona: null,
  correo: '',
  contrasena: '_',
  bancaActiva: 0,
  celularOferta: '',
  DatosVerificados: null,
  intentosEnviarOTP: 1,
}

const mutations = {
  establecerDireccion(state) {
    const datDom = {
      calle: '',
      numExt: '',
      numInt: '',
      cp: '',
      selectedEntidad: {
        id_entidad_federativa: 0,
        val: '',
      },
      selectedColonia: '',
      selectedMunicipio: {
        id_localidad: 0,
        val: '',
      },
    }
    // const datDom = {
    //   calle: payload.Calle ? payload.Calle : '',
    //   numExt: payload.No_Ext ? payload.No_Ext : '',
    //   numInt: payload.No_Int ? payload.No_Int : '',
    //   cp: payload.Codigo_Postal ? payload.Codigo_Postal : '',
    //   selectedEntidad: {
    //     id_entidad_federativa: 0,
    //     val: payload.Estado ? payload.Estado : '',
    //   },
    //   selectedColonia: payload.Id_Colonia_CNBV
    //     ? {
    //         Id_Colonia_CNBV: payload.Id_Colonia_CNBV
    //           ? payload.Id_Colonia_CNBV
    //           : '',
    //         Nombre_Colonia: payload.colonia ? payload.colonia : '',
    //       }
    //     : '',
    //   selectedMunicipio: {
    //     id_localidad: 0,
    //     val: payload.Ciudad ? payload.Ciudad : '',
    //   },
    // }
    state.persona.datosDomicilio = datDom
  },
  updateDireccion(state, payload) {
    state.persona.datosDomicilio = payload
  },
  establecerDatosPersonales(state, payload) {
    let nombreBienvenida = ''
    let nombre = ''
    if ('nombre_s' in payload) {
      nombreBienvenida = payload.nombre_s
        ? payload.nombre_s.at(0).toUpperCase() +
          payload.nombre_s.slice(1).split(' ')[0].toLowerCase()
        : ''
      nombre = payload.nombre_s ?? ''
    } else if ('Nombre_s' in payload) {
      nombreBienvenida = payload.Nombre_s
        ? payload.Nombre_s.at(0).toUpperCase() +
          payload.Nombre_s.slice(1).split(' ')[0].toLowerCase()
        : ''
      nombre = payload.Nombre_s ?? ''
    }
    const datosPersonales = {
      numero: payload.Numero ? payload.Numero : '',
      nombreBienvenida,
      nombre,
      apellidoP: payload.Apellido_Paterno ?? '',
      apellidoM: payload.Apellido_Materno ?? '',
      rfc: payload.Rfc ?? '',
      curp: payload.Curp ?? '',
      fechaNacimiento: payload.Fecha_Nacimiento ?? '',
      celular: payload.Celular ?? '',
    }
    const datosPersona = {
      tipoPersona: payload.Id_tipo_persona ? payload.Id_tipo_persona : '',
      bancaActiva: payload.banca_activa ? payload.banca_activa : '0',
    }
    state.persona.datosPersonales = datosPersonales
    state.persona = { ...state.persona, datosPersona }
    state.persona.tipoPersona =
      payload.Id_tipo_persona ?? state.persona.tipoPersona
    state.generoPersona = payload.Curp ? payload.Curp.charAt(10) : 'H'
  },
  establecerDatosPersona(state, payload) {
    state.persona = payload
  },
  establecerMotivosCancelacion(state, payload) {
    state.motivosCancelacion = payload
  },
  establecerBancaActiva(state, payload) {
    state.bancaActiva = payload
  },
  establecerCorreo(state, payload) {
    state.correo = payload
  },
  establecerContrasena(state, payload) {
    state.contrasena = payload
  },
  setDomicilioOriginal(state) {
    Object.assign(state.domicilioOriginal, state.persona.datosDomicilio)
  },
  setIdDomicilio(state, payload) {
    state.persona.Id_domicilio = payload
  },
  establecerCelularOferta(state, payload) {
    state.celularOferta = payload
  },
  establecerDatosVerificados(state, payload) {
    state.DatosVerificados = payload
  },
  establecerIntentosEnviarOTP(state) {
    // state.intentosEnviarOTP = payload
    state.intentosEnviarOTP++
  },
}

const actions = {
  establecerDireccion(context, payload) {
    context.commit('establecerDireccion', payload)
    context.commit('setDomicilioOriginal')
    context.commit('setIdDomicilio', payload.Id_domicilio)
  },
  actualizarDireccion(context, payload) {
    context.commit('updateDireccion', payload)
  },
  actualizarDatosPersonales(context, payload) {
    context.commit('establecerDatosPersonales', payload)
  },
  establecerMotivosCancelacion(context, payload) {
    context.commit('establecerMotivosCancelacion', payload.motivosCancelacion)
  },
  establecerCorreo(context, payload) {
    context.commit('establecerCorreo', payload)
  },
  establecerContrasena(context, payload) {
    context.commit('establecerContrasena', payload)
  },
  establecerCelularOferta(context, payload) {
    context.commit('establecerCelularOferta', payload)
  },
  establecerDatosVerificados(context, payload) {
    context.commit('establecerDatosVerificados', payload)
  },
  establecerIntentosEnviarOTP(context, payload) {
    context.commit('establecerIntentosEnviarOTP', payload)
  },
}

const getters = {
  obtenerPersona(state) {
    return state.persona
  },
  obtenerDireccion(state) {
    return state.persona.datosDomicilio
  },
  obtenerDireccionOriginal(state) {
    return state.domicilioOriginal
  },
  obtenerMotivosCancelacion(state) {
    return state.motivosCancelacion
  },
  obtenerPersonaRequest(state, _, _2, rootGetters) {
    return {
      numero: state.persona.datosPersonales.numero,
      id_producto: rootGetters['credito/obtenerCredito'].tipoCredito,
      id_tipo_persona: state.persona.tipoPersona,
      telefono: state.persona.datosPersonales.celular,
    }
  },
  obtenerGeneroPersona(state) {
    return state.generoPersona
  },
  obtenerEnviarOtpRequest(state, _, _2, rootGetters) {
    // console.log('a', state.intentosEnviarOTP)
    // state.intentosEnviarOTP++
    // console.log('b', state.intentosEnviarOTP)
    return {
      numero:
        process.env.NODE_ENV === 'production'
          ? state.persona.datosPersonales.numero
          : process.env.VUE_APP_NUMERO_SOCIO_QA,
      id_tipo_persona:
        process.env.NODE_ENV === 'production' ? state.persona.tipoPersona : 1,
      celular:
        process.env.NODE_ENV === 'production'
          ? state.celularOferta
          : process.env.VUE_APP_CELULAR_QA,
      id_producto: rootGetters['credito/obtenerCredito'].tipoCredito,
      isWhats: state.intentosEnviarOTP % 2 == 0 ? 1 : 0,
    }
  },

  obtenerValidaOtpRequest(state, _, _2, rootGetters) {
    return {
      numero:
        process.env.NODE_ENV === 'production'
          ? state.persona.datosPersonales.numero
          : process.env.VUE_APP_NUMERO_SOCIO_QA,
      id_tipo_persona:
        process.env.NODE_ENV === 'production' ? state.persona.tipoPersona : 1,
      telefono:
        process.env.NODE_ENV === 'production'
          ? state.celularOferta
          : process.env.VUE_APP_CELULAR_QA,
      otp: rootGetters['credito/obtenerOtpInicio'],
    }
  },
  obtenerValidaOtpFirmaRequest(state, _, _2, rootGetters) {
    return {
      numero:
        process.env.NODE_ENV === 'production'
          ? state.persona.datosPersonales.numero
          : process.env.VUE_APP_NUMERO_SOCIO_QA,
      id_tipo_persona:
        process.env.NODE_ENV === 'production' ? state.persona.tipoPersona : 1,
      telefono:
        process.env.NODE_ENV === 'production'
          ? state.celularOferta
          : process.env.VUE_APP_CELULAR_QA,
      otp: rootGetters['credito/obtenerOtpFirma'],
    }
  },
  obtenerEsBancaActiva(state) {
    return state.bancaActiva
  },
  obtenerCorreo(state) {
    return state.correo
  },
  obtenerContrasena(state) {
    return state.contrasena
  },
  obtenerTelefono(state) {
    return state.celularOferta
  },
  obtenerCelularOferta(state) {
    return state.celularOferta
  },
  obtenerDatosVerificados(state) {
    return state.DatosVerificados
  },
}

export default {
  strict: true,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
